export default class Student {

  constructor(student, userCanSeeSuccessScore, allowPreferredEmail) {
    this.student = student;
    this.userCanSeeSuccessScore = userCanSeeSuccessScore || false;
    this.allowPreferredEmail = allowPreferredEmail || false;
  }

  get id() {
    return this.student.id;
  }

  get hasPhoto() {
    return this.student.hasPhoto;
  }

  get studentId() {
    return this.student.studentId;
  }

  get fullName() {
    return this.student.fullName;
  }

  get name() {
    return this.student.firstName + ' ' + this.student.lastName;
  }

  get studentType() {
    return this.student.studentType || "student";
  }

  get email() {
    if (this.allowPreferredEmail && this.student.correspondenceTo === 'PREFERRED_MAIL' && this.student.preferredEmail) {
      return this.student.preferredEmail;
    }
    return this.student.email;
  }

  get phone() {
    return this.student.phone;
  }

  get cellphone() {
    return this.student.cellphone;
  }

  get lastUpdatedDate() {
    return this.student.lastUpdatedDate;
  }

  get successScore() {
    return !this.userCanSeeSuccessScore ? -1 : this.student.successScore;
  }

  get uuid() {
    return this.student.uuid;
  }

}
